import request from '../utils/request'
import global from '../config/global'

import { CipherType } from '../core-js/src/enums'

async function list_ciphers(projectId = null) {
  return await global.jsCore.searchService.searchCiphers(
    null,
    [
      c => !c.isDeleted && c.type === CipherType.LeakedSecret,
      c => !projectId || c.organizationId == projectId,
    ],
    null
  ) || []
}

function list(project_id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_LEAKED_SECRETS.replace(':id', project_id),
    method: 'get',
    params
  })
}

function get(project_id, id, params = {}) {
  return request({
    url: global.endpoint.PROJECT_LEAKED_SECRETS.replace(':id', project_id).replace(':secret_id', id),
    method: 'get',
    params
  })
}

export default {
  list_ciphers,
  list,
  get,
}
